module.exports = __webpack_public_path__ + "img/glasses-model1.3586945f.png";